"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ClinicianAccountInfo = _interopRequireDefault(require("./ClinicianAccountInfo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ClinicianAccountInfo.default;
exports.default = _default;